// extracted by mini-css-extract-plugin
export var closeButton = "_10-5";
export var container = "_10-0";
export var contentContainer = "_10-1";
export var desktop = "_10-2";
export var fullModalImage = "_10-6";
export var mobile = "_10-3";
export var withImage = "_10-4";